import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import './ContactHelpDeskModal.css'

const DEFAULT_CHANNELS = [
    { value: 'call', label: 'Call' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'app_chat', label: 'App chat' },
]

/**
 * Reusable help-desk contact popup.
 * @param {boolean} show
 * @param {() => void} onClose
 * @param {(payload: { channel: string, message: string }) => void} [onSend]
 * @param {string} [title]
 * @param {{ value: string, label: string }[]} [channels]
 * @param {string} [defaultChannel]
 * @param {string} [placeholder]
 */
export default function ContactHelpDeskModal({
    show,
    onClose,
    onSend,
    title = 'Contact the help desk',
    channels = DEFAULT_CHANNELS,
    defaultChannel = 'call',
    placeholder = 'How can we help?',
}) {
    const [channel, setChannel] = useState(defaultChannel)
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (show) {
            setChannel(defaultChannel)
            setMessage('')
        }
    }, [show, defaultChannel])

    const handleSend = () => {
        const payload = { channel, message: message.trim() }
        if (typeof onSend === 'function') {
            onSend(payload)
        }
        onClose?.()
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            dialogClassName="chd-modal"
            contentClassName="chd-modal__content"
        >
            <div className="chd-modal__body">
                <h2 className="chd-modal__title">{title}</h2>

                <div className="chd-field">
                    <label className="chd-label">Reach me on</label>
                    <div className="chd-channels" role="tablist" aria-label="Reach me on">
                        {channels.map((item) => (
                            <button
                                key={item.value}
                                type="button"
                                role="tab"
                                aria-selected={channel === item.value}
                                className={`chd-channel ${channel === item.value ? 'chd-channel--active' : ''}`}
                                onClick={() => setChannel(item.value)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="chd-field">
                    <label className="chd-label" htmlFor="chd-message">Message</label>
                    <input
                        id="chd-message"
                        type="text"
                        className="chd-input"
                        placeholder={placeholder}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>

                <div className="chd-actions">
                    <button type="button" className="chd-btn chd-btn--cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button type="button" className="chd-btn chd-btn--send" onClick={handleSend}>
                        Send
                    </button>
                </div>
            </div>
        </Modal>
    )
}
